import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { selectOrganizationUnitsListItems } from "../../redux/organizationUnits/selector";


const Sidebar = () => {
  let items: any = []
  let subitems: any = []
  let menuitems: any = []
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const result = useSelector(selectCurrent)
  const [logo, setLogo] = useState<any>()
  const organizationLists = useSelector(selectOrganizationUnitsListItems)
  const { sidebar, theme } = result
  const [open, setOpen] = useState(items)
  const [isMore, setIsMore] = useState(false)
  const [subOpen, setSubOpen] = useState(subitems)
  const [menuOpen, setMenuOpen] = useState(menuitems)
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeSubIndex, setActiveSubIndex] = useState(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [menus, setMenus] = useState([

 

    // Start - SidebarMenu List - CMS
    {
      id: `main-menu-2-all`,
      path: '/candidate/wip',
      label: 'Job Posts',
      
      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),
      subMenu: [],
    },
   
     {
      id: `main-menu-2-all`,
      path: '/candidate/lms/certified-users',
      label: 'LMS',
      
      Description: 'Content Management System (CMS) is a computer software used to manage the creation and modification of digital content. CMS are typically used for enterprise content management',
      isEnabled: true,
      svg: (
        <svg className="h-6 w-6 mr-1" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 3.75c-4.14214 0-7.5 3.35786-7.5 7.5s3.35786 7.5 7.5 7.5 7.5-3.35786 7.5-7.5-3.35786-7.5-7.5-7.5zm0 1.5c3.58986 0 6.5 2.91014 6.5 6.5s-2.91014 6.5-6.5 6.5-6.5-2.91014-6.5-6.5 2.91014-6.5 6.5-6.5zM12 11.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M12 14.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
          </g>
        </svg>

      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'learning-paths',
          path: '/candidate/lms/learning-paths',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
         {
          id: `coln-1-Categories`,
          label: 'certified-users',
          path: '/candidate/lms/certified-users',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
         {
          id: `coln-1-Categories`,
          label: 'certificates',
          path: '/candidate/lms/certificates',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Collections',
          path: '/candidate/lms/collections',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Topics',
          path: '/candidate/lms/topics',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fill-rule="evenodd" d="M20 10a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1zM7 14.019zm5 2.001a1 1 0 0 1-1 1 1.021 1.021 0 0 1-.79-.38l-.04-.06A6.177 6.177 0 0 0 7 14.15 3.663 3.663 0 0 0 6 14v1.02a.976.976 0 0 1-.55.87 1 1 0 0 1-1.05-.09l-4-3a1 1 0 0 1 0-1.6l4-3a.99.99 0 0 1 1.05-.09.988.988 0 0 1 .55.87V10c2.15 0 5.91 3.1 6 6.02zM20 14a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0-12a1 1 0 0 1-1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1z"></path>
                <path fill="#ffffff" fill-rule="evenodd" d="M24 2v20a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2v-3a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.487.487 0 0 0-.49-.5H8.5a.5.5 0 0 0-.5.5V5a1 1 0 0 1-2 0V2a2.006 2.006 0 0 1 2-2h14a2.006 2.006 0 0 1 2 2z"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Courses',
          path: '/candidate/lms/courses',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1 2h16v11H1z"></path>
                <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M4 5.5v5s3-1 5 0v-5s-2-2-5 0zM9 5.5v5s3-1 5 0v-5s-2-2-5 0z"></path>
                <path fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8.5 14l-3 3h7l-3-3z"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Modules',
          path: '/candidate/lms/modules',
          isEnabled: true,
          svg: (
            <svg fill="#ffffff" className="h-5 w-5 fill-current mr-2" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M1581.176 1072.47h-225.882v438.551l-366.833 213.685c-17.506 10.278-39.416 10.278-56.922 0L564.706 1511.02v-438.55H338.824V685.647c0-20.103 10.842-38.739 28.009-48.79l310.814-181.045v164.894h564.706V455.812l310.814 181.044c17.167 10.052 28.01 28.688 28.01 48.791v386.824Zm112.942 0V685.648c0-60.085-32.189-116.216-84.142-146.485L1242.353 325.14V56H677.647v269.139L310.024 539.162c-51.953 30.269-84.142 86.4-84.142 146.485v386.824H0v564.705h557.026l317.703 185.111c26.429 15.36 55.68 23.04 85.271 23.04 29.59 0 58.955-7.68 85.27-23.04l317.704-185.11H1920V1072.47h-225.882Z" fill-rule="evenodd"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Chapters',
          path: '/candidate/lms/chapters',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M0 0h48v48H0z" fill="none"></path>
                <g id="Shopicon">
                  <rect x="16.002" y="22.002" width="25.997" height="4"></rect>
                  <rect x="16.002" y="11.995" width="25.997" height="4"></rect>
                  <rect x="16.002" y="32.008" width="25.997" height="4"></rect>
                  <rect x="6" y="12" width="4" height="4"></rect>
                  <rect x="6" y="22.006" width="4" height="4"></rect>
                  <rect x="6" y="32.013" width="4" height="4"></rect>
                </g> </g>
            </svg>
          ),
        },
      ],
    },

   
  ]
  )
  menus?.map((item) => {
    items.push({ open: true, isActive: false })
    item?.subMenu?.map((obj:any) => {
      obj?.subMenu?.map((obj1) => {
        menuitems.push({ open: true, isActive: false })
      })
      subitems.push({ open: true, isActive: false })
    })
  })


  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      let menu = [...open]
      open?.map((obj: any, idx: any) => {
        // menu[idx].isActive = false
        menu[idx].open = true
      })
      setOpen(menu)
      let menu1 = [...subOpen]
      subOpen?.map((obj: any, idx: any) => {
        // menu1[idx].isActive = false
        menu1[idx].open = true
      })
      setSubOpen(menu1)
      let menu2 = [...menuitems]
      menuitems?.map((obj: any, idx: any) => {
        // menu2[idx].isActive = false
        menu2[idx].open = true
      })
      setMenuOpen(menu2)
    }
  };

  const handleItemClick = (index: any) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const handleSubItemClick = (index: any) => {
    setActiveSubIndex(index === activeSubIndex ? null : index);
  };

  const handleSideBarView = () => {
    dispatch(settings.set({ sidebar: !sidebar }))
  }

  const fetchLogo = () => {

    const storeData = {
      logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
      }),
      logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Dark'
      }),
      storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
      description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
      favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
    }
    setLogo(storeData)
  }
  useEffect(() => {
    if (storePersist?.get("organizationUnits")?.isSuccess) {
      fetchLogo()
    }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
   
  }, [])

  const handleNavigate = (data: any) => {
    navigate(`${data}`)
  }

  const handleMenu = (index: any, index1: any) => {
    let menu = [...open]
    open?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setOpen(menu)
  }
  const handleSubMenu = (e: any, index: any) => {
    e.stopPropagation()
    let menu = [...subOpen]
    subOpen?.map((obj: any, idx: any) => {
      if (idx == index) {
        menu[idx].open = !obj.open
        menu[idx].isActive = true
      }
      else {
        menu[idx].open = true
        menu[idx].isActive = false
      }
    })
    setSubOpen(menu)
  }
  const handleItems = (e: any, itemIndex: any) => {
    e.stopPropagation()
    let menu2 = [...menuitems]
    menuitems?.map((obj: any, idx: any) => {
      if (idx == itemIndex) {
        menu2[idx].isActive = true
        menu2[idx].open = !obj.open
      }
      else {
        menu2[idx].isActive = false
        menu2[idx].open = true
      }
    })
    setMenuOpen(menu2)
  }

  const beginWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }
    const words = sentence.trim().split(/\s+/);
    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      let transformedSentence = ""
      if (words.length == 1) {
        transformedSentence = `${words[0]} `;
      }
      else if (words.length == 2)
        transformedSentence = `${words[0]} ${words[1]}`;
      return transformedSentence
    }
    else {
      return sentence
    }
  }

  const endWord = (sentence: string | undefined | null) => {
    if (!sentence || typeof sentence !== 'string') {
      return '';
    }
    const words = sentence.trim().split(/\s+/);
    if (words.length === 0) {
      return '';
    }
    if (sentence.length > 19) {
      const lastWord = words.pop() as string;
      return lastWord
    }
  }

  return (
    <>
      {sidebar ? <div className="w-64 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >
        {sidebar &&
          <div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
            <svg
              onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
              width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                <title>Show Less Infomation</title>
              <path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
            </svg>
          </div>
        }
        <div className="h-[calc(100vh-10rem)] overflow-auto">
          <div className="mb-4  px-4 h-max ">
            {menus.map((obj: any, index1: any) => {
              return <li
                onClick={() => handleMenu(index1, null)}
                className={`w-full flex flex-col justify-start space-y-3 `}>
                <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  dark:hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
                  {obj?.svg}
                  <span onClick={() => handleNavigate(obj?.path)} className="dark:hover:text-black w-36 text-sm ">{obj.label}</span>
                </div>
                {obj?.subMenu?.map((obj1: any, index2: any) => {
                  return <ul
                    onClick={(e) => handleSubMenu(e, index2)}
                    className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
                    <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                      {obj1?.svg}
                      <div onClick={() => handleNavigate(obj1?.path)} className="text-light  text-sm dark:text-slate-200 dark:hover:text-black w-36  flex flex-col w-auto justify-center items-end">
                        <span className="">{beginWord(obj1.label)}</span>
                        <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                      </div>
                    </div>
                    {obj1?.subMenu?.map((obj2: any, index3: any) => {
                      return <li
                        onClick={(e) => handleItems(e, index3)}
                        className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                        <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj2?.svg}
                          <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj2.label)}</span>
                            <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                          </div>
                        </div>
                      </li>
                    })}
                  </ul>
                })}
              </li>
            })}
          </div>
        </div>
        </div> : <div ref={dropdownRef} className="w-24 fixed md:top-0 md:left-0 h-screen lg:block bg-primary text-light z-10" >
        <div className="">
          {!sidebar &&
            <div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
              <svg
                onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                  <title>Show More Infomation</title>
                <path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
              </svg>
            </div>
          }
          <div className="mb-4 px-4 h-max ">
            <ul className="w-full flex flex-col justify-start space-y-3">
              {!isMore && menus.map((barmenu: any, index1: any) => {
                return <li
                  className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 8 ? 'hidden' : ""} `}
                  onClick={() => handleMenu(index1, null)} >
                  <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                    {barmenu?.svg}
                  </div>
                  <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary text-light ml-0 ${index1 > 4 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                    {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                      return <ul
                        onClick={(e) => handleSubMenu(e, index2)}
                        className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                        <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj1?.svg}
                          <div onClick={() => handleNavigate(obj1?.path)} className="text-light  text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj1.label)}</span>
                            <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                          </div>
                        </div>
                        {obj1?.subMenu?.map((obj2: any, index3: any) => {
                          return <li
                            onClick={(e) => handleItems(e, index3)}
                            className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                            <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                              {obj2?.svg}
                              <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">

                                <span className="">{beginWord(obj2.label)}</span>
                                <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                              </div>
                            </div>
                          </li>
                        })}
                      </ul>
                    })}
                  </ul>
                </li>
              })}
              {isMore && menus.map((barmenu: any, index1: any) => {
                return <li
                  className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 < 8 ? 'hidden' : ""} `}
                  onClick={() => handleMenu(index1, null)} >
                  <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                    {barmenu?.svg}
                  </div>
                  <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary dark:bg-slate-800 ml-0 ${index1 > 12 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                    {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                      return <ul
                        onClick={(e) => handleSubMenu(e, index2)}
                        className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                        <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                          {obj1?.svg}
                          <div onClick={() => handleNavigate(obj1?.path)} className="text-light text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                            <span className="">{beginWord(obj1.label)}</span>
                            <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                          </div>
                        </div>
                        {obj1?.subMenu?.map((obj2: any, index3: any) => {
                          return <li
                            onClick={(e) => handleItems(e, index3)}
                            className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                            <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                              {obj2?.svg}
                              <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                                <span className="">{beginWord(obj2.label)}</span>
                                <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                              </div>
                            </div>
                          </li>
                        })}
                      </ul>
                    })}
                  </ul>
                </li>
              })}
            </ul>
          </div>
        </div>
        <div
          onClick={() => setIsMore(!isMore)}
          className="w-24 text-xs text-right px-4 text-blue-500 underline cursor-pointer">
          {!isMore ? 'More' : 'Less'}
        </div>
      </div>}
    </>
  )
}

export default Sidebar;